import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Button from '../components/ui/Button';
export default function NotFound() {
  return (
    
      <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6 py-12">
        <div className="text-center">
          <ExclamationTriangleIcon className="h-16 w-16 text-teal-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900">404 - Page not found</h1>
          <p className="mt-2 text-sm text-gray-600">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <Link to="/" className="mt-6 inline-block">
            <Button variant="primary" size="md" className="text-sm">
              Go back home
            </Button>
          </Link>
        </div>
      </div>
    
  );
}